import api from "../../../utils/api";
import { getJson } from "../../../lib/http";
import { DEFAULT_SETTINGS, PARAM_KEYS, type ScoreSettings } from "./drivingScore";

const URL = "/companies/driving-score-settings";

export interface LoadedSettings {
  settings: ScoreSettings;
  customized: boolean;
  // false = el API todavía no tiene el endpoint (Functions sin desplegar): se
  // califica con los de por omisión y lo que se cambie sólo dura la sesión.
  available: boolean;
}

const normalize = (raw: any): ScoreSettings => ({
  ecoSpeedKmh: Number(raw?.ecoSpeedKmh ?? DEFAULT_SETTINGS.ecoSpeedKmh),
  speedLimitKmh: Number(raw?.speedLimitKmh ?? DEFAULT_SETTINGS.speedLimitKmh),
  idleMinutes: Number(raw?.idleMinutes ?? DEFAULT_SETTINGS.idleMinutes),
  eventsPer100kmForZero: Number(raw?.eventsPer100kmForZero ?? DEFAULT_SETTINGS.eventsPer100kmForZero),
  weights: Object.fromEntries(
    PARAM_KEYS.map((k) => [k, Number(raw?.weights?.[k] ?? DEFAULT_SETTINGS.weights[k])]),
  ) as ScoreSettings["weights"],
});

const status = (e: unknown) => (e as { response?: { status?: number } })?.response?.status;

export async function fetchScoreSettings(companyId: string): Promise<LoadedSettings> {
  try {
    const res = await getJson<{ data: { data: any } }>(URL, {}, undefined, { headers: { "x-company-id": companyId } });
    const d = res?.data?.data;
    return { settings: normalize(d), customized: Boolean(d?.customized), available: true };
  } catch (e) {
    if (status(e) === 404) return { settings: DEFAULT_SETTINGS, customized: false, available: false };
    throw e;
  }
}

export async function saveScoreSettings(companyId: string, settings: ScoreSettings): Promise<ScoreSettings> {
  const res = await api.put(URL, settings, { headers: { "x-company-id": companyId } });
  return normalize(res.data?.data?.data);
}

export const settingsErrorMessage = (e: unknown): string => {
  const s = status(e);
  if (s === 403) return "Sólo el admin reseller o el administrador de la compañía pueden cambiar los ajustes.";
  if (s === 404) return "El servidor todavía no tiene esta función: los ajustes se aplican sólo en esta sesión.";
  const msg = (e as { response?: { data?: { data?: { message?: string } } } })?.response?.data?.data?.message;
  return msg || "No se pudieron guardar los ajustes.";
};
